import { ExtensionKeys } from '../../actions/types';
var isEditableAIPanel = function isEditableAIPanel(node) {
  var _node$type, _node$attrs;
  return ((_node$type = node.type) === null || _node$type === void 0 ? void 0 : _node$type.name) === 'bodiedExtension' && [ExtensionKeys.AISummaryBodiedExtension, ExtensionKeys.AIActionItemsBodiedExtension].includes((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.extensionKey);
};
var canHostAIPanel = function canHostAIPanel(node) {
  var _node$type2, _node$type3;
  return ((_node$type2 = node.type) === null || _node$type2 === void 0 ? void 0 : _node$type2.name) === 'layoutSection' || ((_node$type3 = node.type) === null || _node$type3 === void 0 ? void 0 : _node$type3.name) === 'layoutColumn';
};
export var getNewlyEditedAIPanels = function getNewlyEditedAIPanels(_ref) {
  var transactions = _ref.transactions,
    knownEditedPanelIds = _ref.knownEditedPanelIds;
  var changed = [];
  transactions.forEach(function (tr) {
    var _tr$getMeta;
    if (tr.docChanged && !((_tr$getMeta = tr.getMeta) !== null && _tr$getMeta !== void 0 && _tr$getMeta.call(tr, 'appendedTransaction'))) {
      var olds = [];
      var news = [];
      tr.before.descendants(function (node) {
        if (isEditableAIPanel(node)) {
          olds.push(node);
        } else if (canHostAIPanel(node)) {
          return true;
        }
        return false;
      });
      tr.doc.descendants(function (node) {
        if (isEditableAIPanel(node)) {
          news.push(node);
        } else if (canHostAIPanel(node)) {
          return true;
        }
        return false;
      });
      if (olds.length !== news.length) {
        return;
      }
      olds.forEach(function (old, i) {
        if (!old.content.eq(news[i].content)) {
          changed.push(news[i]);
        }
      });
    }
  });
  if (changed.length) {
    return changed.reduce(function (accum, node) {
      if (!knownEditedPanelIds[node.attrs.localId]) {
        accum[node.attrs.localId] = {
          extensionKey: node.attrs.extensionKey,
          extensionType: 'com.atlassian.ai-blocks'
        };
      }
      return accum;
    }, {});
  } else {
    return {};
  }
};